import * as React from "react";
import {
  Create,
  SimpleForm,
  required,
  TextInput,
  AutocompleteInput,
  useGetList,
  useNotify,
} from "react-admin";
import { CustomToolbar, Loader } from "../../shared/components/index.js";

const Clients = () => {
  const notify = useNotify();
  const {
    total,
    error: countError,
    isLoading: countLoading,
  } = useGetList("Client", {
    pagination: { page: 1, perPage: 1 },
    meta: { includeTotal: true },
  });

  const [clientData, setClientData] = React.useState([]);
  const { data, error, isLoading } = useGetList("Client", {
    pagination: { page: 1, perPage: total || 10000 },
    enabled: !!total,
  });

  React.useEffect(() => {
    if (data && data.length) {
      setClientData(data);
    }
  }, [data]);

  if (countError || error) {
    return notify(
      `resources.notifications.errors.${error?.message || countError?.message}`,
      {
        type: "error",
      }
    );
  }

  if (countLoading || isLoading) {
    return <Loader />;
  }

  if (!countLoading && !isLoading && clientData) {
    const jurClients = clientData.filter(
      (jur_client) => jur_client.entity === 2
    );
    const phyClients = clientData.filter(
      (phy_client) => phy_client.entity === 1
    );

    return (
      <>
        <AutocompleteInput
          sx={{ width: "20%" }}
          inputProps={{ maxLength: 64 }}
          inputText={(record) => record.first_name}
          source="card_owner"
          choices={jurClients}
          optionText="first_name"
          optionValue="id_clients"
          debounce={10}
          validate={[required()]}
          filterToQuery={(searchText) => ({ first_name: searchText })}
          isLoading={isLoading}
          label="resources.QrCard.source.card_owner"
        />
        <AutocompleteInput
          sx={{ width: "20%" }}
          inputProps={{ maxLength: 12 }}
          inputText={(record) => record.phone}
          source="card_holder"
          choices={phyClients}
          optionText="phone"
          optionValue="id_clients"
          debounce={10}
          validate={[required()]}
          filterToQuery={(searchText) => ({ phone: searchText })}
          isLoading={isLoading}
          label="resources.QrCard.source.card_holder"
        />
      </>
    );
  }
};

const CreateQrCard = () => (
  <Create redirect="show">
    <SimpleForm toolbar={<CustomToolbar />}>
      <Clients />
      <TextInput
        sx={{ width: "20%" }}
        inputProps={{ maxLength: 8 }}
        source="pin1"
        validate={[required()]}
      />
    </SimpleForm>
  </Create>
);

export default CreateQrCard;
